<template>
    <div class="top-menu-popup" :style="`height: ${windowHeight}px;`">
        <div>
            <div class="d-flex justify-content-between">
                <router-link to="/">
                    <div class="logo"></div>
                </router-link>
                <div class="close">
                    <img src="../../../../../assets/images/svg/white/icone_close.svg" height="24px" @click="$emit('click')"/>
                </div>
            </div>
        </div>
        <div class="text-center my-5 py-5 text-white">
            <h2>
                <a class="nav-link" href="javascript:void(0)" @click="cosaFareNY()">{{TOP_LINK_COSA_FARE}}</a>
            </h2>
            <h2 v-if="TOP_LINK_CAMBIA_ISOLA !== undefined">
                <a class="nav-link" href="javascript:void(0)" @click="cambiaIsola()">{{TOP_LINK_CAMBIA_ISOLA}}</a>
            </h2>
            <h2>
                <a class="nav-link" :href="TOP_LINK_CHI_SIAMO_URL" target="_blank" @click="trackHomeChiSiamo">{{TOP_LINK_CHI_SIAMO}}</a>
            </h2>
            <h2>
                <a class="nav-link" v-if="!isAuthenticated()" href="javascript:void(0)" @click="loginAgenzia">{{TOP_LINK_AGENZIA}}</a>
                <a class="nav-link" v-else href="javascript:void(0)" @click="logoutAgenzia">Agenzia {{token()}} - Logout</a>
            </h2>
        </div>
        <div class="d-flex justify-content-between p-2 text-center">
            <div>
                <a href="https://www.qualitygroup.it/" target="_blank" class="logo-sx image-contain"></a>
            </div>
            <div v-if="LOGO_EXTERNAL_1 !== undefined">
                <a :href="LOGO_EXTERNAL_1" :target="LOGO_EXTERNAL_1 != 'javascript:void(0);' ? '_blank' : '_self'" class="logo1 image-contain"></a>
            </div>
            <!--div v-if="LOGO_EXTERNAL_2 !== undefined">
                <a :href="LOGO_EXTERNAL_2" :target="LOGO_EXTERNAL_1 != 'javascript:void(0);' ? '_blank' : '_self'" class="logo2 image-contain"></a>
            </div-->
            <div v-if="LOGO_EXTERNAL_3 !== undefined">
                <a :href="LOGO_EXTERNAL_3" :target="LOGO_EXTERNAL_1 != 'javascript:void(0);' ? '_blank' : '_self'" class="logo3 image-contain"></a>
            </div>
            <div class="text-logo no-wrap text-uppercase"><span>Un progetto</span></div>
            <div>
                <a :href="TOP_LINK_CHI_SIAMO_URL" target="_blank" class="logo-dx image-contain"></a>
            </div>
        </div>
    </div>
</template>

<script>
import AnalyticEvents from '../../../../common/AnalyticEvents'
import TopNavigationDesktop from '../../../../pages/layout/common/TopNavigation'
import ContentUtils from '../../../../utils/ContentUtils'

export default {
  name: 'TopMenuPopup',
  mixins: [AnalyticEvents, TopNavigationDesktop, ContentUtils]
}
</script>



// WEBPACK FOOTER //
// src/front/components/mobile/pages/layout/common/TopMenuPopup.vue